import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminCartLink from "@/pages/admin/AdminCartLink";

export const Route = createFileRoute("/admin/cart-link")({
  head: () => pageHead("Admin \u2014 Cart Link \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminCartLink,
});
